import cn from 'classnames';
import React, { useEffect, useState } from 'react';
import clear_img from '../../../../assets/media/icons/close.svg';
import { TYPE_INPUT } from '../../../../constans';
import Button from '../../Buttons/Button';
import Icon from '../../Elements/Icon';
import InputLabel from '../LabelInput';
import InputBase from './InputBase';
import styles from './styles.module.scss';

const Input = React.forwardRef(({
  updateValue = false,
  placeholder = '',
  value = '',
  maxLength,
  readOnly = false,
  onClickEnter = () => { },
  onChange = () => { },
  onRawChange = () => { },
  onBlur = () => { },
  onFocus = () => { },
  onMouseLeave = (_) => _,
  showLabel = false,
  type = 'text',
  disabled = false,
  cursor,
  error = '',
  width,
  height,
  fontSize,
  fontWeight,
  noBorder = false,
  autocomplete = 'off',
  validate = false,
  valid = true,
  small = false,
  label = '',
  min,
  max,
  leftText = false,
  textAlign,
  autoFocus = false,
  paddingLeft,
  paddingRight,
  preventState = false,
  preventDefault = false,
  blackLabel = false,
  clear = false,
  className,
  center = false,
  bold = false,
  theme = '',
  children,
  color,
  ...props
}, forwardedRef) => {
  const [data, changeData] = useState(value !== 0 ? value || '' : 0); // FIXME?
  const [focus, changeFocus] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClickEnter(data);
    }
  };

  function onChangeData(e, text) {
    if (preventDefault) {
      e.preventDefault();
    } else {
      if (!preventState) {
        changeData(text);
      }
      onChange(text, e);
    }
  }

  useEffect(() => {
    changeData(value !== 0 ? value || '' : 0);
  }, [value, updateValue]);

  useEffect(() => {
    if (forwardedRef && autoFocus) {
      forwardedRef.current.focus();
    }
  }, [forwardedRef, autoFocus]);

  return (
    <div
      className={cn(
        styles.input_block,
        label.length > 0 && styles.input_label,
        label.length > 0 && validate && styles.input_block_validate,
      )}
      style={{ ...props.style }}
    >
      {label.length > 0 && (!disabled || data.length > 0) && (
        <InputLabel black={blackLabel} animation={data.length === 0 && placeholder === '' && !focus && !showLabel}>
          {label}
        </InputLabel>
      )}
      <InputBase
        type={type}
        maxLength={maxLength}
        disabled={disabled}
        onFocus={() => {
          changeFocus(true);
          onFocus(); focus
        }}
        onBlur={() => {
          changeFocus(false);
          onBlur(data);
        }}
        autoComplete={autocomplete}
        className={cn(
          styles.input,
          leftText && styles.text_left,
          small && styles.input_small,
          !valid && focus && styles.not_valid,
          error.length > 0 && !focus && styles.error,
          noBorder && styles.no_border,
          clear && styles.input_clear,
          center && styles.input_center,
          bold && styles.input_bold,
          className,
          theme === TYPE_INPUT.BLUE && styles.theme,
          props.styles,
        )}
        ref={forwardedRef}
        value={data}
        style={{ width, height, fontSize, paddingLeft, paddingRight, cursor, textAlign, fontWeight, color }}
        onKeyDown={(e) => handleKeyDown(e)}
        onChange={(e) => {
          onChangeData(e, e.target.value);
          onRawChange(e);
        }}
        readOnly={readOnly}
        placeholder={disabled && label.length > 0 && placeholder === '' ? label : placeholder}
      />
      {clear && data.length > 0 && (
        <Button className={small ? styles.clear_button_small : styles.clear_button} onClick={() => changeData('')}>
          <Icon src={clear_img} width={small ? 9 : 12} height={small ? 9 : 12} />
        </Button>
      )}

      {error.length > 0 && (
        <span className={styles.error_message} style={{ maxWidth: width }}>
          {!focus && error}
        </span>
      )}
      {children}
    </div>
  );
})

export default Input;
